import { FormEvent, useState } from "react";
import { ApiError } from "../../api/client";
import { UserRow, resetUserPassword } from "../../api/users";
import "./UserFormModal.css";

export function PasswordResetModal(props: {
  user: UserRow;
  onClose: () => void;
  onDone: () => void;
}) {
  const { user, onClose, onDone } = props;
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [done, setDone] = useState(false);

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await resetUserPassword(user.id, password);
      setDone(true);
    } catch (err) {
      setError(err instanceof ApiError ? err.message : "Parola sifirlanamadi.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="kp-user-modal-backdrop" role="dialog" aria-modal="true">
      <div className="kp-user-modal">
        <header className="kp-user-modal__header">
          <h3>Parolayi Sıfırla</h3>
          <button className="kp-user-modal__close" onClick={onClose}>x</button>
        </header>
        {!done && (
          <form onSubmit={onSubmit} className="kp-user-modal__body">
            <div className="kp-muted" style={{ fontSize: 13 }}>
              <strong>{user.full_name}</strong> ({user.email}) icin yeni parola olustur.
            </div>
            <label className="kp-user-field">
              <span>Yeni Parola <em>*</em></span>
              <input
                type="text"
                minLength={8}
                maxLength={128}
                required
                value={password}
                disabled={busy}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="En az 8 karakter, harf + rakam"
              />
              <small className="kp-muted">
                Bu parolayi kullaniciya guvenli bir kanalla iletin. Ilk girisinde
                degistirebilir.
              </small>
            </label>
            {error && <div className="kp-user-modal__error">{error}</div>}
            <div className="kp-user-modal__actions">
              <button type="button" className="kp-btn" onClick={onClose} disabled={busy}>
                Vazgeç
              </button>
              <button
                type="submit"
                className="kp-btn kp-btn--primary"
                disabled={busy || password.length < 8}
              >
                {busy ? "Kaydediliyor…" : "Sıfırla"}
              </button>
            </div>
          </form>
        )}
        {done && (
          <div className="kp-user-modal__body">
            <div
              style={{
                background: "#ecfdf5",
                border: "1px solid #a7f3d0",
                color: "#065f46",
                padding: "12px 14px",
                borderRadius: 10,
                fontSize: 13.5,
              }}
            >
              Parola Başarıyla Güncellendi. Yeni parolayi kullaniciya iletmeyi unutmayin.
            </div>
            <div className="kp-user-modal__actions">
              <button
                type="button"
                className="kp-btn kp-btn--primary"
                onClick={() => {
                  onDone();
                  onClose();
                }}
              >
                Tamam
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
